export enum LinkTargetEnum {
    BLANK = 'BLANK',
    SELF = 'SELF',
}
